var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendBulkMessage1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    rx: 125,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M215 125.199C215 75.3877 174.701 35 125 35C75.2986 35 35 75.3877 35 125.199C35 175.011 75.2986 215.398 125 215.398C151.754 215.398 155.895 211.247 168.881 203.955C182.873 205.189 198.657 210.462 203.582 212.257C204.366 212.594 205.261 211.92 205.261 211.135C206.269 189.483 204.478 175.684 203.358 169.513C210.746 156.387 215 141.242 215 125.087V125.199Z",
    fill: "#243F22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.442 79.7641C146.83 72.1353 134.293 72.1353 126.681 79.7641C119.069 87.3929 119.069 99.9579 126.681 107.587L134.628 115.552L141.905 122.844C159.927 140.907 161.046 170.412 143.584 189.035C125.449 208.332 94.8899 208.668 76.3078 190.045L68.3601 182.08C63.0989 176.807 56.4944 174.787 50.2257 175.46C66.3451 199.581 93.8825 215.512 125.114 215.512C151.755 215.512 156.009 211.361 168.994 204.068C182.987 205.302 198.77 210.575 203.696 212.37C204.479 212.707 205.375 212.034 205.375 211.248C206.382 189.596 204.591 175.797 203.472 169.627C208.621 160.427 212.315 150.218 213.994 139.448L154.442 79.7641Z",
    fill: "url(#paint0_linear_7448_1918)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125 35C80.112 35 42.8358 67.9832 36.1194 111.063L95.6717 170.747C103.731 178.825 117.276 178.376 124.664 169.289C131.157 161.436 130.149 149.656 122.985 142.476L115.373 134.847L107.425 126.882C98.2463 117.683 93.6568 105.678 93.6568 93.6743C93.6568 81.6702 98.2463 69.5539 107.425 60.4667C125.672 42.18 155.448 42.18 173.806 60.4667L181.754 68.432C187.015 73.7048 193.619 75.7242 199.888 75.0511C183.769 50.9307 156.231 35 125 35Z",
    fill: "url(#paint1_linear_7448_1918)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7448_1918",
    x1: 50.1138,
    y1: 144.721,
    x2: 213.882,
    y2: 144.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12A84A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#12A649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#139F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#159342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#18823B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1C6C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243F22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7448_1918",
    x1: 145.149,
    y1: 136.53,
    x2: 69.3497,
    y2: 15.8543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12A84A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#12A649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#139F46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#159342"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#18823B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1C6C33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#243F22"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendBulkMessage1);
export default __webpack_public_path__ + "static/media/Send Bulk Message1.47620b541f869c5f6417c4527d736347.svg";
export { ForwardRef as ReactComponent };